import { render, staticRenderFns } from "./ProjectDefaultSettings.vue?vue&type=template&id=61c06ab9"
import script from "./ProjectDefaultSettings.vue?vue&type=script&lang=js"
export * from "./ProjectDefaultSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports